.root {
  font-family: var(--font-sans);
  font-weight: var(--font-weight-light);
  line-height: 165%;
  letter-spacing: var(--font-small-letter-spacing);
  overflow-wrap: break-word;
  white-space: pre-wrap;

  p {
    margin: 1.5rem 0;
    font-size: var(--font-size-body-1);
  }
  /* ...map more HTML elements here a needed */
}
